/*
 *
 * ----------------------------------------------- */

jQuery(function ($) {
  $(".section-introduction-effect table").addClass("table table-bordered table-header-blue");
});
